
import { useDispatch, useSelector} from 'react-redux'
import { createStyles,Button,Group} from '@mantine/core';
import { Refresh  } from 'tabler-icons-react';
import intl from 'react-intl-universal';
import { clear_setclientlanguage } from '../slice/mainslice';



const useStyles = createStyles((theme) => ({
  vcenter: {
    marginTop: '10vh',
    textAlign: 'center',
  },
}));



/**
 * Renders a rejoin button component that requests a new join link when clicked.
 *
 * A function that requests a new join link.
 * After lost connection, this function requests a new Capsule link for CMS Meeting
 * Usdn on Notar and KLient Client
 * 
 *
 * @meetinginfo: {Object} - state.user.meetinginfo - The current meeting information.
 * @angchange: {boolean} - state.user.changelanguage - Have User Changed the language? 
 * 
 * @return {JSX.Element} The rejoin button component.
 */
const RejoinButton = () => {
    const { classes } = useStyles();
    const dispatch = useDispatch()
    const meetinginfo = useSelector((state: any) => state.user.meetinginfo)
    const langchange = useSelector((state: any) => state.user.changelanguage)

    let meetingdrnid: number
    meetingdrnid = parseInt(meetinginfo.drnId)

    let loading = false
    let buttonmessage

    // Change Message on Language Change or Lost Connection
    if(!langchange){
      buttonmessage = intl.get('VIDEO_BUTTON_REJOIN')
    } else {
      buttonmessage = intl.get('VIDEO_BUTTON_REJOIN_CHANGELANG')
    }

    /**
     * A function that requests a new join link.
     * After lost connection, this function requests a new Capsule link for CMS Meeting
    */
    const requestnewjoinlink = () => {
      loading = true
      const payload = {
        meetingId: meetingdrnid,
      };

    // Request Startmeeting
    dispatch({ type: 'SIGNALR_REQUESTREJOINMEETING', payload: payload });
    dispatch(clear_setclientlanguage());
    }
 
  return (
   <>
   <Group position="center" className={classes.vcenter}>
      <Button 
          leftIcon={<Refresh size="2rem" />} 
          variant="filled" 
          color="green" 
          size="lg" 
          radius="md" 
          loading = {loading}
          loaderPosition="right" 
          onClick={() => requestnewjoinlink()}> {buttonmessage} 
      </Button>
   </Group>
   </>
   
  );
}

export default RejoinButton ;